module.exports = __webpack_public_path__ + "img/pinpad.78570b10.svg";